export default class SpecialistController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/specialist/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/delete', 'post', params, axiosOption, httpOption);
  }

  static appoint (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/appoint', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowSpecialistAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/startOnly/flowSpecialistAudit', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowSpecialistAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/startWithBusinessKey/flowSpecialistAudit', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowSpecialistAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/startAndTakeUserTask/flowSpecialistAudit', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowSpecialistAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/startAndSaveDraft/flowSpecialistAudit', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowSpecialistAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/submitUserTask/flowSpecialistAudit', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowSpecialistAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/viewTaskBusinessData/flowSpecialistAudit', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowSpecialistAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/viewHistoricTaskBusinessData/flowSpecialistAudit', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowSpecialistAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialist/listWorkOrder/flowSpecialistAudit', 'post', params, axiosOption, httpOption);
  }
}
